import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Headers, RequestOptions, Response } from '@angular/http'
import { Globals } from './../helpers'
import { HttpInterceptor } from './http-error.interceptor'

@Injectable()
export class DistributionService {
  private distributionServiceUrl: string

  constructor(private http: HttpClient, private globals: Globals) {
    this.distributionServiceUrl = globals.url + 'distribution/'
  }

  public getJobs(group?: number) {
    return this.http
      .get(this.distributionServiceUrl + 'jobs')
      .map((response: Response) => response.json())
  }
  public getStats() {
    return this.http
      .get(this.distributionServiceUrl + 'stats')
      .map((response: Response) => response.json())
  }
  public deleteDoneJobs() {
    return this.http
      .delete(this.distributionServiceUrl + 'jobs')
      .map((response: Response) => response.json())
  }

  public getDeviceSyncObject(deviceId: string) {
    return this.http
      .get(this.distributionServiceUrl + 'sync/device/' + deviceId)
      .map((response: Response) => response.json())
  }
  public syncDevice(deviceId: string) {
    return this.http
      .put(
        this.distributionServiceUrl + 'sync/device/' + deviceId,
        null,

      )
      .map((response: Response) => response.json())
  }
  public stopSyncDevice(deviceId: string) {
    return this.http
      .delete(
        this.distributionServiceUrl + 'sync/device/' + deviceId,

      )
      .map((response: Response) => response.json())
  }

  public getPackageSyncObject(packageId: string) {
    return this.http
      .get(
        this.distributionServiceUrl + 'sync/package/' + packageId,

      )
      .map((response: Response) => response.json())
  }
  public syncPackage(packageId: string) {
    return this.http
      .put(
        this.distributionServiceUrl + 'sync/package/' + packageId,
        null,

      )
      .map((response: Response) => response.json())
  }

  public getDevicePackageSyncState(deviceId: string, packageId: string) {
    return this.http
      .get(
        this.distributionServiceUrl +
        'sync/device/' +
        deviceId +
        '/package/' +
        packageId,

      )
      .map((response: Response) => response.json())
  }
  public syncDevicePackage(deviceId: string, packageId: string) {
    return this.http
      .put(
        this.distributionServiceUrl +
        'sync/device/' +
        deviceId +
        '/package/' +
        packageId,
        null,

      )
      .map((response: Response) => response.json())
  }

  private jwt() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'))
    const headers = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded'
    })
    if (currentUser && currentUser.token) {
      headers.append('Authorization', 'Bearer ' + currentUser.token)
    }
    return new RequestOptions({ headers })
  }
}
